import { TableFilterConfig } from '@/components/data-table/filters-v2';
import i18n from '@/core/i18n';
import { DEFAULT_PAGE_SIZE_PROJECTS_SHORT_ENTITIES } from '@/lib/constants/pagination';
import { AvatarName, getBillStatusOptions } from '@/modules/common';
import { CustomAttribute } from '@/modules/common/types/custom-attribute';
import { buildCustomAttributeFilterConfigsV2 } from '@/modules/common/utils/custom-attribute-filters';
import { getShortProjects } from '@/modules/projects';
import { renderProjectFilterLabelWithAvatar } from '@/modules/projects/helpers/project-dropdown-option';
import { getShortTeamMembers } from '@/modules/team';

import { BillStatus } from '../types';
import {
  BILLS_FILTER_KEY_MEMBER,
  BILLS_FILTER_KEY_PROJECT,
  BILLS_FILTER_KEY_SEARCH,
  BILLS_FILTER_KEY_STATUS,
} from './bills-filter-keys';

export const SEARCH_FILTER_MIN_CHARACTERS = 2;

// NOTE: the billing-period date range is rendered as a standalone DateRangePickerV2
// next to the filters (see bills-page.tsx), not as a dropdown filter.
export const getBillingFilterConfig = (
  customAttributes?: CustomAttribute[]
): TableFilterConfig[] => [
  {
    type: 'search',
    name: BILLS_FILTER_KEY_SEARCH,
    label: i18n.t('authenticated.bills:filters.search.placeholder'),
    placeholder: i18n.t('authenticated.bills:filters.search.placeholder'),
    minCharacters: SEARCH_FILTER_MIN_CHARACTERS,
  },
  {
    type: 'autocomplete',
    name: BILLS_FILTER_KEY_STATUS,
    label: i18n.t('authenticated.bills:filters.status'),
    displayDot: true,
    options: getBillStatusOptions([
      BillStatus.Open,
      BillStatus.Overdue,
      BillStatus.Paid,
      BillStatus.InProgress,
      BillStatus.Error,
    ]),
  },
  {
    type: 'dynamic-autocomplete',
    name: BILLS_FILTER_KEY_PROJECT,
    label: i18n.t('authenticated.bills:filters.project'),
    withSearch: true,
    loadOptions: async params =>
      getShortProjects({
        filter: { searchString: params.searchString },
        pagination: { cursor: params.cursor, pageSize: DEFAULT_PAGE_SIZE_PROJECTS_SHORT_ENTITIES },
      }),
    renderLabel: renderProjectFilterLabelWithAvatar,
  },
  {
    type: 'dynamic-autocomplete',
    name: BILLS_FILTER_KEY_MEMBER,
    label: i18n.t('authenticated.bills:filters.memberName'),
    withSearch: true,
    loadOptions: async params =>
      getShortTeamMembers({
        filter: { searchString: params.searchString },
        pagination: { cursor: params.cursor, pageSize: DEFAULT_PAGE_SIZE_PROJECTS_SHORT_ENTITIES },
      }),
    renderLabel: (value: string) => <AvatarName name={value} />,
  },
  ...(customAttributes
    ? buildCustomAttributeFilterConfigsV2(customAttributes, 4, {
        noValueOptionLabel: i18n.t('common:tableFilters.noAttributeValue'),
      })
    : []),
];
